import React from "react"
import types from "prop-types"
import {
  customNameInSentence,
  customNameWithArticle,
  pluralizeCustomName,
} from "utils/customNameHelpers"

// A name is entered once but read in several forms, and the capitalization it is
// entered with decides how those forms come out.  Naming where each form appears is
// what makes a weak entry ("care center" under a heading) visible before it is saved.
const CustomNamePreview = ({ name }) => {
  const forms = [
    { appearsIn: "heading or label", form: name },
    { appearsIn: "heading or label, plural", form: pluralizeCustomName(name) },
    { appearsIn: "within a sentence", form: customNameWithArticle(name) },
    { appearsIn: "within a sentence, plural", form: pluralizeCustomName(customNameInSentence(name)) },
  ]

  return (
    <div>
      <span className="block mb-1">Preview</span>
      <div className="rounded-lg border border-light overflow-hidden">
        <ul className="p-0 m-0">
          {
            forms.map(({ appearsIn, form }) => (
              <li
                className="flex items-baseline justify-between gap-4 px-4 pb-2 first:pt-2 border-b last:border-b-0 border-light mb-2 last:mb-0"
                key={appearsIn}
              >
                <span>{form}</span>
                <span className="text-xs text-dark whitespace-nowrap">{appearsIn}</span>
              </li>
            ))
          }
        </ul>
      </div>
    </div>
  )
}

CustomNamePreview.propTypes = {
  name: types.string.isRequired,
}

export default CustomNamePreview
